import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@bloomcode/ui';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Bloomcode Ledger Portal</title>
      </Helmet>

      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-muted-foreground font-[Manrope]">404</h1>
          <p className="mt-4 text-xl">Page not found</p>
          <p className="mt-2 text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="mt-8 inline-block">
            <Button>Go Home</Button>
          </Link>
        </div>
      </div>
    </>
  );
}
